module.exports = __webpack_public_path__ + "static/media/reports.dc5c8d2c.png";